<div class="container-fluid">
  <app-pagetitle
    title="Cost"
    [breadcrumbItems]="breadCrumbItems"
  ></app-pagetitle>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="row d-flex justify-content-between">
            <div class="col-md-6">
              <a
                class="btn btn-success mb-2"
                (click)="openModal(content, '', 'Add')"
              >
                <span> <i class="mdi mdi-plus mr-2"></i> Add Cost</span>
              </a>
            </div>
            <div class="col-md-6 d-flex align-items-center">
              <select
                class="form-control"
                name="select"
                id="select"
                [(ngModel)]="selectedType"
                (change)="selectType($event.target.value)"
                style="color: black"
              >
                <option value="" disabled>Select Costtype</option>
                <option [value]="data.value" *ngFor="let data of costTypeData">
                  {{ data.costType }}
                </option>
              </select>
              <input
                type="text"
                class="form-control ml-2"
                placeholder="Search..."
                [(ngModel)]="searchText"
              />
            </div>
          </div>
          <div class="table-responsive mt-3" *ngIf="finalRes?.length != 0">
            <table
              *ngIf="selectedType == 'fixed'"
              class="table table-striped table-bordered table-centered datatable dt-responsive nowrap"
              style="border-collapse: collapse; border-spacing: 0; width: 100%"
            >
              <thead class="thead-dark">
                <tr>
                  <th>Cost Name</th>
                  <th>Cost Per Hour/kWh</th>
                  <th style="width: 120px">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr  *ngFor="
                  let item of finalRes
                    | filter : searchText
                    | slice : pageSize
                    | slice : 0 : itemsPerPage;
                  let i = index
                ">
                  <td>{{ item?.costName }}</td>
                  <td>{{ item?.cost }} {{ item?.currencyUnit }}</td>
                  <td>
                    <a
                      (click)="openModal(content, item, 'Edit')"
                      class="mr-3 text-primary"
                      v-b-tooltip.hover
                      title="Edit"
                      style="cursor: pointer"
                    >
                      <i class="mdi mdi-pencil font-size-18"></i>
                    </a>
                    <a *ngIf="item.costName != 'EnergyCost'"
                      class="text-danger"
                      v-b-tooltip.hover
                      title="Delete"
                      style="cursor: pointer"
                      (click)="openModalDelete(deletetemp, item)"
                    >
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              *ngIf="selectedType == 'variable'"
            class="table table-striped table-bordered table-centered datatable dt-responsive nowrap"
              style="border-collapse: collapse; border-spacing: 0; width: 100%"
            >
              <thead class="thead-dark ">
                <tr>
                  <th>Cost Name</th>
                  <th>Material Per Part</th>
                  <th>Material Per Hour</th>
                  <th>Unit</th>
                  <th>Cost</th>
                  <th style="width: 120px">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                *ngFor="
                  let item of finalRes
                    | filter : searchText
                    | slice : pageSize
                    | slice : 0 : itemsPerPage;
                  let i = index
                ">
                  <td>{{ item?.costName }}</td>
                  <td>{{ item?.materialPerPart || "-" }}</td>
                  <td>{{ item?.materialPerHour || "-" }}</td>
                  <td>{{ item?.unit }}</td>
                  <td>{{ item?.cost }} {{ item?.currencyUnit }}</td>
                  <td>
                    <a
                      (click)="openModal(content, item, 'Edit')"
                      class="mr-3 text-primary"
                      v-b-tooltip.hover
                      title="Edit"
                      style="cursor: pointer"
                    >
                      <i class="mdi mdi-pencil font-size-18"></i>
                    </a>
                    <a
                      class="text-danger"
                      v-b-tooltip.hover
                      title="Delete"
                      style="cursor: pointer"
                      (click)="openModalDelete(deletetemp, item)"
                    >
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <div class="col-md-6" *ngIf="finalRes?.length > 5">
              <ngb-pagination
                class="pagination-rounded"
                [collectionSize]="finalRes?.length"
                #numPages
                [pageSize]="itemsPerPage"
                [(page)]="currentPage"
                [maxSize]="1"
                [rotate]="true"
                [ellipses]="false"
                [boundaryLinks]="true"
                (pageChange)="onPageChange(currentPage)"
              >
              </ngb-pagination>
            </div>
          </div>
          <div class="card" *ngIf="finalRes?.length == 0">
            <div class="row justify-content-center">
              <span *ngIf="errmsg == ''"
                ><strong>No Cost Found. Add Cost to view</strong></span
              >
              <span *ngIf="errmsg != ''"
                ><strong>{{ errmsg }}</strong></span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Reaons model  -->
<ng-template #content role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">{{ action }} Cost</h5>
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left" *ngIf="selectedType == 'fixed'">
      <form (ngSubmit)="saveData()" [formGroup]="costForm" autocomplete="off">
        <div class="row ">
          <div class="col-md-6">
            <div class="form-group">
            <label for="costName">Cost Name</label>
            <input
              type="text"
              class="form-control"
              id="costName"
              placeholder="Enter Cost Name"
              formControlName="costName"
              [ngClass]="{ 'is-invalid': submitted && form.costName.errors }"
              [title]="
                costForm.get('costName')?.disabled ? 'Field is disabled' : ''
              "
            />
            <div
              *ngIf="submitted && form.costName.errors"
              class="invalid-feedback"
            >
              <span *ngIf="form.costName.errors.required"
                >Cost Name is mandatory.</span
              >
            </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
            <label for="cost">{{ costForm.get('costName')?.value === 'EnergyCost' ? 'Cost per kWh' : 'Cost per Hour' }}</label>
            <div class="d-flex">
              <ngx-intl-tel-input
                class="auth-form-group-custom2"
                [ngClass]="{
                  'is-invalid': submitted && form.cost.errors
                }"
                [preferredCountries]="preferredCountries"
                [enableAutoCountrySelect]="true"
                [enablePlaceholder]="false"
                [searchCountryFlag]="true"
                [searchCountryField]="[
                  SearchCountryField.Iso2,
                  SearchCountryField.Name
                ]"
                [selectFirstCountry]="false"
                [selectedCountryISO]="CountryISO.India"
                [phoneValidation]="false"
                [separateDialCode]="separateDialCode"
                name="cost"
                formControlName="cost"
                (countryChange)="onCountryChange($event)"
                (input)="limitTo8Digits($event)"
              >
              </ngx-intl-tel-input>
              <input type="number" class="formField" [(ngModel)]="costValue" (input)="limitTo8DigitswithDecimel($event)" [ngModelOptions]="{standalone: true}" placeholder="Enter Cost"/>
              <input type="hidden" formControlName="currencyUnit" />
              <span
                class="input-group-text"
                style="font-weight: bold; font-size: 14px"
              >
                {{ currencySymbol }}
              </span>
            </div>
            <div
              *ngIf="submitted && form.cost?.errors?.required"
              class="invalid-feedback"
            >
              <span>Cost is required.</span>
            </div>
          </div>
          </div>
        </div>
        <div class="text-right">
          <button [disabled]="isZero" type="submit" class="btn btn-success">Save</button>
          <button type="button" class="btn btn-danger ml-1" (click)="cancel()">
            Cancel
          </button>
        </div>
      </form>
    </div>
    <div class="text-left" *ngIf="selectedType == 'variable'">
      <form (ngSubmit)="saveData()" [formGroup]="costForm" autocomplete="off">
        <div class="row">
          <div class="form-group col-md-6">
            <label for="costName">Cost Name</label>
            <input
              type="text"
              class="form-control"
              id="costName"
              placeholder="Enter Cost Name"
              formControlName="costName"
              [ngClass]="{ 'is-invalid': submitted && form.costName.errors }"
              [title]="
                costForm.get('costName')?.disabled ? 'Field is disabled' : ''
              "
            />
            <div
              *ngIf="submitted && form.costName.errors"
              class="invalid-feedback"
            >
              <span *ngIf="form.costName.errors.required"
                >Cost Name is mandatory.</span
              >
            </div>
          </div>
          <div class="form-group col-md-6">
            <label for="materialType">Material Type</label>
            <select
              class="form-control"
              name="materialType"
              id="materialType"
              formControlName="materialType"
            >
              <option>Material Per Part</option>
              <option>Material Per Hour</option>
            </select>
            <div
              *ngIf="submitted && form.materialType?.errors?.required"
              class="invalid-feedback"
            >
              <span>Material type required.</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6"  *ngIf="costForm.get('materialType')['value'] == 'Material Per Part'">
            <label for="materialPerPart">Quantity</label>
            <input
              type="number"
              class="form-control"
              id="materialPerPart"
              placeholder="Enter Material Per Part"
              formControlName="materialPerPart"
              [ngClass]="{ 'is-invalid': submitted && form.materialPerPart.errors }"
              [title]="
                costForm.get('materialPerPart')?.disabled ? 'Field is disabled' : ''
              "
            />
            <div
              *ngIf="submitted && form.materialPerPart.errors"
              class="invalid-feedback"
            >
              <span *ngIf="form.materialPerPart.errors.required"
                >Material Per Part is mandatory.</span
              >
            </div>
          </div>
          <div class="form-group col-md-6" *ngIf="costForm.get('materialType')['value'] == 'Material Per Hour'">
            <label for="materialPerHour">Quantity</label>
            <input
              type="number"
              class="form-control"
              id="materialPerHour"
              placeholder="Enter Material Per Hour"
              formControlName="materialPerHour"
              [ngClass]="{ 'is-invalid': submitted && form.materialPerHour.errors }"
              [title]="
                costForm.get('materialPerHour')?.disabled ? 'Field is disabled' : ''
              "
            />
            <div
              *ngIf="submitted && form.materialPerHour.errors"
              class="invalid-feedback"
            >
              <span *ngIf="form.materialPerHour.errors.required"
                >Material Per Hour is mandatory.</span
              >
            </div>
          </div>
          <div class="form-group col-md-6">
            <label for="unit">Unit</label>
            <select
              class="form-control"
              name="unit"
              id="unit"
              formControlName="unit"
            >
            <option value="" selected>Select Unit</option>
            <option *ngFor="let unit of siUnits" [value]="unit.value">
              {{ unit.label }}
            </option>
            </select>
            <div
              *ngIf="submitted && form.unit?.errors?.required"
              class="invalid-feedback"
            >
              <span>Material type required.</span>
            </div>
          </div>
           <div class="col-md-6">
            <div class="form-group">
            <label for="cost">Cost</label>
            <div class="d-flex">
              <ngx-intl-tel-input
                class="auth-form-group-custom2"
                [ngClass]="{
                  'is-invalid': submitted && form.cost.errors
                }"
                [preferredCountries]="preferredCountries"
                [enableAutoCountrySelect]="true"
                [enablePlaceholder]="false"
                [searchCountryFlag]="true"
                [searchCountryField]="[
                  SearchCountryField.Iso2,
                  SearchCountryField.Name
                ]"
                [selectFirstCountry]="false"
                [selectedCountryISO]="CountryISO.India"
                [phoneValidation]="false"
                [separateDialCode]="separateDialCode"
                name="cost"
                formControlName="cost"
                (countryChange)="onCountryChange($event)"
                (input)="limitTo8Digits($event)"
              >
              </ngx-intl-tel-input>
              <input type="number" class="formField" [(ngModel)]="costValue" (input)="limitTo8DigitswithDecimel($event)" [ngModelOptions]="{standalone: true}" placeholder="Enter Cost"/>
              <input type="hidden" formControlName="currencyUnit" />
              <span
                class="input-group-text"
                style="font-weight: bold; font-size: 14px"
              >
                {{ currencySymbol }}
              </span>
            </div>
            <div
              *ngIf="submitted && form.cost?.errors?.required"
              class="invalid-feedback"
            >
              <span>Cost is required.</span>
            </div>
          </div>
          </div>
        </div>
        <div class="text-right">
          <button  [disabled]="isZero" type="submit" class="btn btn-success">Save</button>
          <button type="button" class="btn btn-danger ml-1" (click)="cancel()">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<!-- Delete model  -->
<ng-template #deletetemp role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Delete Cost</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div class="example-container">
      <form>
        <div>
          <p>Are you sure to Delete?</p>
        </div>
        <button
          type="submit"
          class="btn btn-danger round waves-effect headr"
          (click)="delete(delcostId)"
        >
          Delete
        </button>
        &nbsp;
        <button
          type="submit"
          class="btn btn-info round waves-effect headr"
          (click)="modal('Cross click')"
        >
          Cancel
        </button>
      </form>
    </div>
  </div>
</ng-template>
